import { ActionBar, FAIconName, Text } from '@equip.health/ui';
import { LANGUAGEV2 } from '~/lib/constants/language.constants';

interface SurveyDataWarningProps {
  isEditMode: boolean;
  onReview?: () => void;
}

const SurveyDataWarning = ({
  isEditMode,
  onReview,
}: SurveyDataWarningProps) => {
  const warningText = (
    <Text>
      <span style={{ fontWeight: 500 }}>
        {LANGUAGEV2.populatedFromSurveyWarning.Title}
      </span>{' '}
      {LANGUAGEV2.populatedFromSurveyWarning.Text}
      {isEditMode ? ', highlighted in yellow.' : '.'}
    </Text>
  );

  return (
    <ActionBar
      barIcon={FAIconName.exclamationCircleRegular}
      id={isEditMode ? 'patient-edit-action-bar' : 'patient-view-action-bar'}
      text={warningText}
      variant="warning"
      {...(!isEditMode && {
        buttonIcon: FAIconName.filePen,
        buttonText: 'Review',
        onButtonClick: onReview,
      })}
    />
  );
};

export default SurveyDataWarning;
